module.exports = __webpack_public_path__ + "static/media/code-instruction.dc83a22f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/code-instruction.jpg
// module id = 89
// module chunks = 0